var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52344 0C3.37802 0 0 3.37802 0 7.52344C0 11.6689 3.37802 15.0469 7.52344 15.0469C11.6689 15.0469 15.0469 11.6689 15.0469 7.52344C15.0469 3.37802 11.6689 0 7.52344 0ZM10.7961 10.2093C10.6908 10.3899 10.5027 10.4877 10.3071 10.4877C10.2093 10.4877 10.1115 10.4651 10.0212 10.4049L7.68896 9.01308C7.10965 8.667 6.68082 7.90714 6.68082 7.23755V4.15294C6.68082 3.84448 6.93661 3.58868 7.24507 3.58868C7.55353 3.58868 7.80933 3.84448 7.80933 4.15294V7.23755C7.80933 7.50839 8.03503 7.90714 8.26826 8.04256L10.6005 9.43439C10.8714 9.59239 10.9617 9.93847 10.7961 10.2093Z",
    fill: "#065F46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.63cb35b50f635bc658fe65059f8a4c1a.svg";
export { ForwardRef as ReactComponent };